import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    console.log('ProtectedRoute - Verificando autenticação, token:', token ? 'existe' : 'não existe');
    return token !== null;
  };

  if (!isAuthenticated()) {
    console.log('ProtectedRoute - Usuário não autenticado, redirecionando para /login');
    return <Navigate to="/login" replace />;
  }

  console.log('ProtectedRoute - Usuário autenticado, renderizando componente');
  return children;
}

export default ProtectedRoute; 